"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapsClientError = void 0;
class MapsClientError extends Error {
    constructor(message, payload) {
        super(message);
        this.payload = payload;
    }
}
exports.MapsClientError = MapsClientError;
//# sourceMappingURL=maps-client-error.js.map